import React, { useState } from 'react'
import { FormControl, TextField } from '@material-ui/core'
import withStyles from '@material-ui/core/styles/withStyles'
import { Link, withRouter } from 'react-router-dom'
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import firebase from '../firebase'
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';

function Alert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

function ForgetPass(props) {
	const { classes } = props

	const [email, setEmail] = useState('')
	const [open, setOpen] = React.useState(false);
	const [msg, setMsg] = React.useState(undefined);
	const [typeMsg, setTypeMsg] = React.useState(undefined);

	const alertMsg = (msg, type) => {
	  setOpen(true);
	  setMsg(msg);
	  setTypeMsg(type);
	};
  
	const handleClose = (event, reason) => {
	  if (reason === 'clickaway') {
		return;
	  }
	  setOpen(false);
	};

	const theme = createMuiTheme({
		palette: {
		  primary: {
			main: '#919191'
		  }
		},
	  });

	  const baseURL = process.env.PUBLIC_URL;

	return (
		<ThemeProvider theme={theme}>
		<main className="login">
			<Snackbar
				anchorOrigin={{
				vertical: 'top',
				horizontal: 'center',
				}}
				open={open}
				autoHideDuration={4000}
				onClose={handleClose}
			>
				<Alert onClose={handleClose} severity={typeMsg}>
					{msg}
					</Alert>
			</Snackbar>
			<header className="loginHeader">
				<img className="logoLogin2" src={require('../../images/logo.svg')} />
				<h3 className="loginHTitleHeader">RECUPERAR CONTRASEÑA</h3>
			</header>
			<form onSubmit={e => e.preventDefault() && false}>
				<FormControl margin="normal" required fullWidth>
					<TextField variant="outlined" color="primary" label="Email" id="email" name="email" autoFocus value={email} onChange={e => setEmail(e.target.value)} />
				</FormControl>
			</form>
			<div className="btnContainerLogin">
				<div type="submit" className="loginBtnPrincipal" onClick={forgetPass}>Recuperar contraseña</div>
				<Link to={baseURL+"/login"}><div className="loginBtnSecundary red">Volver a login</div></Link>
			</div>
		</main>
		</ThemeProvider>
	)

	async function forgetPass() {
		try {
			await firebase.forgetPass(email)
			alertMsg('Hemos enviado un link de recuperación a tu correo', 'info');
		} catch(error) {
			alertMsg(error.message, 'error');
		}
	}
}

export default withRouter(ForgetPass)